import { render, staticRenderFns } from "./ManageRefernceFormat.vue?vue&type=template&id=0747aa4e"
import script from "./ManageRefernceFormat.vue?vue&type=script&lang=js"
export * from "./ManageRefernceFormat.vue?vue&type=script&lang=js"
import style0 from "./ManageRefernceFormat.vue?vue&type=style&index=0&id=0747aa4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports